export enum CallState {
    Started = 'started',
    InitialTranscriptStreamed = 'initialTranscriptStreamed',
    Ended = 'ended',
}
